import {$clientApi} from "../http";
import {IPaymentMethod} from "../models/IPaymentMethod";


class PaymentMethodServiceClass {

    async getPaymentMethodsByCustomerId(customerId: number) {
        return $clientApi.get<IPaymentMethod[]>(`api/payment-methods?customerId=${customerId}`);
    }

    async setDefaultPaymentMethod(customerId: number, paymentMethodId: string) {
        return $clientApi.put(`api/payment-methods/${paymentMethodId}`, { customerId });
    }

    async deletePaymentMethod(paymentMethodId: string) {
        return $clientApi.delete(`api/payment-methods/${paymentMethodId}`);
    }

    async addPaymentMethod(paymentMethodId: string, customerId: number) {
        return $clientApi.post<any>(`api/payment-methods`, {
            paymentMethodId,
            customerId
        });
    }

}

export const PaymentMethodService = new PaymentMethodServiceClass();